import { ServiceAction } from "./service-part-action"

/**
 * Whether a component does its job, judged separately from how much of its
 * lifetime is left: a nearly new derailleur can still shift badly.
 */
export enum PartFunction {
  WORKS = "WORKS",
  NOT_OPTIMAL = "NOT_OPTIMAL",
  NOT_WORKING = "NOT_WORKING",
}

export class PartFunctionUtils {
  static isImpaired(partFunction: PartFunction): boolean {
    return partFunction !== PartFunction.WORKS
  }

  /**
   * A component that doesn't work must get an action before the inspection
   * moves on. "Gör inget" counts: the customer is then told the workshop
   * recommends nothing for now.
   */
  static isMissingAction(part: {
    partFunction: PartFunction
    recommendedAction: ServiceAction | null
  }): boolean {
    return (
      PartFunctionUtils.isImpaired(part.partFunction) &&
      part.recommendedAction === null
    )
  }
}
